module.exports = __webpack_public_path__ + "3e2cb56a841f1a16e6dbeed8e557974c.svg";